import { MixpanelTracker } from "./MixPanelTracker";
import { MixpanelTrackerMock } from "./MixpanelTrackerMock";
import { useMock } from "../utils/useMock";

export default (useMock() ? MixpanelTrackerMock : MixpanelTracker);